export const SORT_DIRECTION = {
  ASCEND: 'ascend',
  ASC: 'asc',
  DESCEND: 'descend',
  DESC: 'desc',
};
